<div class="ml-2 flex h-16 flex-row space-x-5">
  <div
    tp="Turn off formula to activate control"
    [tpIsEnabled]="isDisabled === true"
  >
    <ng-select
      #fractionQuarterOfYearTypeSelect
      [fixNgSelectBottom]="fractionQuarterOfYearTypeSelect"
      data-cy="fractionQuarterOfYearTypeSelect"
      class="fraction-type-select w-48"
      [items]="fractionQuarterOfYearTypesList"
      [clearable]="false"
      [searchable]="false"
      [disabled]="isDisabled === true"
      [(ngModel)]="fraction.type"
      (change)="typeChange($event)"
      (keyup.esc)="
        $event.stopImmediatePropagation();
        fractionQuarterOfYearTypeSelect.blur()
      "
      (keyup.enter)="
        $event.stopImmediatePropagation();
        fractionQuarterOfYearTypeSelect.blur()
      "
      appendTo="body"
      bindLabel="label"
      bindValue="value"
    >
      <ng-template ng-label-tmp let-item="item">
        <div class="ml-1 truncate">{{ item.label }}</div>
      </ng-template>

      <ng-template ng-option-tmp let-item="item">
        <div
          class="flex flex-row"
          [ngClass]="{
            'text-yellow-700': item.operator === fractionOperatorEnum.And
          }"
        >
          <div class="ml-1">{{ item.operator | uppercase }} -</div>
          <div class="ml-1 truncate">{{ item.label }}</div>
        </div>
      </ng-template>
    </ng-select>
  </div>

  <div
    *ngIf="
      fraction.type === fractionTypeEnum.QuarterOfYearIs ||
      fraction.type === fractionTypeEnum.QuarterOfYearIsNot
    "
    tp="Turn off formula to activate control"
    [tpIsEnabled]="isDisabled === true"
  >
    <ng-select
      #fractionQuarterOfYearValueSelect
      [fixNgSelectBottom]="fractionQuarterOfYearValueSelect"
      data-cy="fractionQuarterOfYearValueSelect"
      class="popup-55 w-48"
      [ngClass]="{
        'cursor-default': isDisabled === true
      }"
      [items]="fractionQuarterOfYearValuesList"
      [clearable]="false"
      [searchable]="false"
      [disabled]="isDisabled === true"
      [(ngModel)]="fraction.quarterOfYearValue"
      (change)="quarterOfYearValueChange($event)"
      (keyup.esc)="
        $event.stopImmediatePropagation();
        fractionQuarterOfYearValueSelect.blur()
      "
      (keyup.enter)="
        $event.stopImmediatePropagation();
        fractionQuarterOfYearValueSelect.blur()
      "
      appendTo="body"
      bindLabel="label"
      bindValue="value"
    >
      <ng-template ng-label-tmp let-item="item">
        <div class="ml-1 truncate">{{ item.label }}</div>
      </ng-template>

      <ng-template ng-option-tmp let-item="item">
        <div class="ml-1 truncate">{{ item.label }}</div>
      </ng-template>
    </ng-select>
  </div>
</div>
